export default __webpack_public_path__ + "images/xlsx_64.png";